import service from '../util/http2'


// 调用客户端禁用启用
export const isUseCustomer = (data) => {
  return service({
    url:  '/customer/account/control',
    method: 'post',
    data
  })
}
// 删除附件接口
export const deleteFile = (data) => {
  return service({
    url: '/customer/system/delete/file',
    method: 'post',
    data
  })
}

// 根据vin获取车主车辆档案
export const getVinData = (data) => {
  return service({
    url: '/customer/quality/vin',
    method: 'post',
    data
  })
}



